import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function useOverallStatistics(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ANALYTICS_QUERY_KEY, "overall-statistics", filters],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/overall-statistics", {
        params: {
          query: toAnalyticsQuery(filters),
        },
      });
      if (error !== undefined) {
        throw new Error("Failed to load overall statistics");
      }
      return data;
    },
  });
}
